import React from "react";
import styled from "styled-components";
import { Modal, ModalBody } from "reactstrap";
import Button from "../button";
import colors from "../../design/colors";
import fonts from "../../design/typography";

/* **********************************
 * TYPES
 ********************************** */
interface ConfirmButton {
  text: string;
  onClick: () => void;
  buttonColor: string;
  textColor?: string;
  width?: string;
  height?: string;
  fontStyle?: React.CSSProperties;
}

interface ConfirmModalProps {
  isOpen: boolean;
  message: React.ReactNode;
  buttons: ConfirmButton[];
  width?: string; // 모달 너비
  height?: string; // 모달 높이
  onClose: () => void; // 외부 클릭
  className?: string; // 커스텀 스타일링을 위한 className
  messageMargin?: string; // message 영역 margin 옵션
  padding?: string; // 모달 내부 padding 옵션
}

/* **********************************
 * COMPONENT
 ********************************** */
const ConfirmModal = ({
  isOpen,
  message,
  buttons,
  onClose,
  width,
  height,
  className,
  messageMargin,
  padding,
}: ConfirmModalProps) => {
  return (
    <StyledModal
      isOpen={isOpen}
      toggle={onClose}
      contentClassName="custom-modal-content"
      width={width}
      height={height}
      padding={padding}
      onClick={(e) => e.stopPropagation()}
    >
      <ModalBody
        onClick={(e) => e.stopPropagation()}
        style={{
          padding: padding ?? "24px",
          width: width,
          height: height ?? "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          className={className}
          style={{
            ...fonts.body2Medium,
            color: colors.gray900,
            textAlign: "center",
            margin: messageMargin ?? "24px 0 32px 0",
          }}
        >
          {message}
        </div>
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          {buttons.map((btn, index) => (
            <Button
              key={index}
              size="medium"
              width={btn.width ?? "112px"}
              height={btn.height ?? "40px"}
              text={btn.text}
              onClick={btn.onClick}
              buttonColor={btn.buttonColor}
              textColor={btn.textColor}
              style={btn.fontStyle}
            />
          ))}
        </div>
      </ModalBody>
    </StyledModal>
  );
};

export default ConfirmModal;

/* **********************************
 * Styles
 ********************************** */
const StyledModal = styled(Modal)<{ width?: string; height?: string }>`
  z-index: 99999 !important;

  .modal-dialog {
    max-width: ${(props) => props.width ?? "max-content"};
    width: ${(props) => props.width ?? "350px"};
    z-index: 99999 !important;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .modal-content {
    z-index: 99999;
    max-width: ${(props) => props.width ?? "350px"};
    width: ${(props) => props.width ?? "350px"};
    max-height: ${(props) => props.height ?? "max-content"};
    height: ${(props) => props.height ?? "max-content"};
    position: relative;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
  }

  .modal-backdrop.show {
    z-index: 99998 !important;
  }
`;
